import {
  BooleanField,
  DateField,
  DeleteButton,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  EditButton,
} from 'react-admin'
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts'
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'

const PlacesUsersShowActions = () => (
  <TopToolbar>
    <Permission permission={PERMISSIONS.UPDATE_LOCAL_USER}>
      <EditButton />
    </Permission>
    <ResendEmailButton />
    <Permission permission={PERMISSIONS.ADMIN}>
      <MarkVerifiedButton />
    </Permission>
    <Permission permission={PERMISSIONS.UPDATE_LOCAL_USER}>
      <DeleteButton mutationMode="pessimistic" redirect="/_employees" confirmTitle="Excluir usuário" />
    </Permission>
  </TopToolbar>
);

const PlacesUsersShow = props => (
  <Permission permission={PERMISSIONS.CREATE_LOCAL_USER}>
    <Show {...props} title="Usuário de local" actions={<PlacesUsersShowActions />}>
      <SimpleShowLayout>
        <EmailVerificationWarning />
        <TextField source="name" label="Nome" />
        <TextField source="login" label="Login (email)" />
        <ReferenceField source="placeId" reference="places" label="Parceiro / Posto" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="profileId" reference="profiles" label="Perfil" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="emailVerified" label="Email verificado" />
        <DateField source="createdAt" label="Criado em" showTime locales="pt-BR" />
      </SimpleShowLayout>
    </Show>
  </Permission>
);

export default PlacesUsersShow;
